<template>
  <div 
    class="logo-wrapper relative z-150 top-[-0.7rem] w-[200px] mx-4"
    ref="logoWrapper"
    @mousemove="handleMouseMove"
    @mouseleave="resetLogoEffect"
  >
    <div class="logo-glow"></div>
    
    <a href="." class="logo-link">
      <img 
        src="\img\STE Logo.png" 
        class="logo relative z-10 translate-y-[20px]" 
        alt="Logo"
        ref="logoImage"
      >
    </a>
  </div>
</template>

<script>
export default {
  name: 'LogoSTE',
  data() {
    return {
      isAnimated: false
    }
  },
  mounted() {
    // Add entrance animation
    setTimeout(() => {
      this.isAnimated = true;
      this.$refs.logoWrapper.classList.add('logo-animated');
    }, 300);
  },
  methods: {
    handleMouseMove(e) {
      if (!this.$refs.logoWrapper || !this.$refs.logoImage) return;
      
      const wrapper = this.$refs.logoWrapper;
      const logo = this.$refs.logoImage;
      
      // Get the bounding rectangle
      const rect = wrapper.getBoundingClientRect();
      
      // Calculate mouse position relative to the center of the logo
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      // Calculate distance from center (normalized from -1 to 1)
      const distanceX = (e.clientX - centerX) / (rect.width / 2);
      const distanceY = (e.clientY - centerY) / (rect.height / 2);
      
      // Apply a subtle 3D transform effect
      logo.style.transform = `
        perspective(800px) 
        rotateY(${distanceX * 5}deg) 
        rotateX(${distanceY * -5}deg) 
        scale(1.05)
      `;
      
      // Move the glow effect based on mouse position
      const glow = wrapper.querySelector('.logo-glow');
      if (glow) {
        glow.style.opacity = '0.7';
        glow.style.left = `${50 + distanceX * 20}%`;
        glow.style.top = `${50 + distanceY * 20}%`;
      }
    },
    resetLogoEffect() {
      if (!this.$refs.logoImage) return;
      
      // Reset transforms
      this.$refs.logoImage.style.transform = 'perspective(800px) rotateY(0deg) rotateX(0deg) scale(1)';
      
      // Reset glow
      const glow = this.$refs.logoWrapper.querySelector('.logo-glow');
      if (glow) {
        glow.style.opacity = '0.3';
        glow.style.left = '50%';
        glow.style.top = '50%';
      }
    }
  }
};
</script>

<style scoped>
.logo-wrapper {
  text-align: center;
  position: relative;
  overflow: visible;
  transform: translateY(20px);
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  /* Adjust positioning to make logo overflow navbar */
  margin-top: -25px;
  margin-bottom: -25px;
  z-index: 160;
  width: auto; /* Let the logo determine its natural width */
  max-width: 200px; /* Set a maximum width for very large screens */
  display: flex;
  justify-content: center;
}

.logo-wrapper.logo-animated {
  transform: translateY(0);
  opacity: 1;
}

.logo-link {
  display: block;
  position: relative;
  z-index: 2;
}

.logo {
  height: auto;
  position: relative;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  will-change: transform;
  filter: drop-shadow(0 5px 10px rgba(0, 0, 0, 0.3));
  max-width: 100%; /* Ensure the logo doesn't exceed its container */
}

/* Glow effect */
.logo-glow {
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(143, 0, 0, 0.5) 0%, transparent 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.3;
  z-index: 1;
  transition: opacity 0.5s ease, left 0.3s ease, top 0.3s ease;
  pointer-events: none;
  filter: blur(10px);
}


.logo-wrapper.logo-animated,
.logo-wrapper.logo-animated  {
  transform: scaleX(1);
}

/* Media queries */
@media (max-width: 768px) {
  .logo-wrapper {
    max-width: 150px;
    margin-top: -10px;
    margin-bottom: -20px;
  }
  
  .logo {
    transform: scale(1.15);
  }
  
  .logo-glow {
    width: 60px;
    height: 60px;
  }
}
</style>